import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import ClientOrder from './ClientOrder'

class SingleClientOrder extends Component {
    constructor(props) {
        super(props)
        let { clientOrder } = this.props.match.params

        this.state = {
            clientOrder,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { clientOrder } = this.state
        // console.log('Loading clientOrder', clientOrder)
        return (
            <View column fullw fullh>
                <ClientOrder forcedOpen={true} showDetails={true} clientOrderId={clientOrder} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleClientOrder)))
